<style>
</style>

<script lang="ts">
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';
    import { validateSubscriptionToken } from './utils/api';

    export let token: string;
    export let status: 'initial' | 'inprogress' | 'success' | 'failed' =
        'initial';
    const unknownErrorMessage = `${$_('generic.errors.unknown')}. ${$_(
        'generic.prompts.try_again'
    )}`;

    export let message = '';
    onMount(() => {
        if (!token) {
            return;
        }
        message = '';
        status = 'initial';
        validateSubscriptionToken(token)
            .then((success) => {
                if (success !== true) {
                    throw new Error(unknownErrorMessage);
                }
                status = 'success';
                message = $_('confirm_subscription.successfully_subscribed');
            })
            .catch((e: unknown) => {
                const error = e as Error;
                status = 'failed';
                message = error.message || unknownErrorMessage;
            });
    });
</script>

<div>
    {#if status == 'inprogress'}
        <h4>
            {$_('confirm_subscription.statuses.confirmation_inprogress')} ...
        </h4>
        <p>{message}</p>
    {/if}
    {#if status == 'success'}
        <h4>{$_('confirm_subscription.statuses.confirmation_successful')}</h4>
        <p>{message}</p>
    {/if}
    {#if status == 'failed'}
        <h4>{$_('confirm_subscription.statuses.confirmation_failed')}</h4>
        <p>{message}</p>
    {/if}
</div>
